import type { MouseEventHandler } from 'react';

import type { DeserializedUser } from '@api';
import { MEMBERSHIP_TIER_ID } from '@api';

import {
  getMembershipClassNames,
  getMembershipName,
  isLastMembershipTier,
} from '@shared/common/components/NavLayout/utils';
import { nextProjectUrl } from '@shared/constants/urls';

import { Membership } from '@ui/uikit/components/icons/mono/Membership';
import { cn } from '@ui/uikit/utils';

import NavLayoutLink from '../NavLayoutLink';

interface ProfileMenuMembershipProps {
  user?: DeserializedUser | null;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  isExternalLink?: boolean;
}

export const ProfileMenuMembership = ({
  user,
  onClick,
  isExternalLink = false,
}: ProfileMenuMembershipProps) => {
  const userMembershipTier = user?.membershipTier.attributes.key ?? MEMBERSHIP_TIER_ID.FREE;
  const isMaxTier = isLastMembershipTier(userMembershipTier);

  return (
    <div className="py-5 gap-1.5 flex items-center justify-between shadow-inset-border-bottom shadow-base-border-light">
      <span className={cn('flex items-center gap-1.5 text-caption-sm-strong-d', 'flex-1 min-w-0')}>
        <Membership
          className={cn(
            'flex-shrink-0',
            'size-4',
            getMembershipClassNames(userMembershipTier).text,
          )}
        />
        <span
          className={cn('truncate', {
            'msq-skeleton-text': !userMembershipTier,
          })}
          data-qa="profile-balance-data-membership"
        >
          {getMembershipName(userMembershipTier)}
        </span>
      </span>

      {!isMaxTier && (
        <NavLayoutLink
          onClick={onClick}
          href={nextProjectUrl.store('/profile/membership/plans')}
          external={isExternalLink}
          className="min-w-[7.25rem] msq-btn msq-btn-secondary msq-btn-md"
        >
          Upgrade
        </NavLayoutLink>
      )}
    </div>
  );
};
